"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    $('.scrollDown__btn').on('click', function () {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.video-with-slider').offset().top
        }, 100);
    });
};
exports.init = init;
